import { Component, Input } from "@angular/core";

import { ClaimStatus } from "@helper/abstraction/yandex-delivery";

@Component({
  selector: "app-claim-icons",
  templateUrl: "./claim-icons.component.html",
  styleUrls: ["./claim-icons.component.scss"]
})
export class ClaimIconsComponent {
	@Input() public status?: ClaimStatus;
}
